import { API_VERSION_ONE_ADMIN } from '../../utils/apiUtils';
import { buildDownloadUrl } from '../../utils/apiHelperUtils';
const path = `/${API_VERSION_ONE_ADMIN}/settings/sample_export`

export default function SampleExportButton(props) {
  const { params, className, label } = props

  return (
    <a download className={`btn ${className}`} href={buildDownloadUrl(path, params)}>{label}</a>
  )
}